// ============================================================
//  SPONSOREN — Firestore-Collection "sponsoren"
//  Ersetzt Sanity fetchSponsoren(). "logo" ist eine Storage-URL.
// ============================================================
import {
  collection,
  doc,
  getDocs,
  query,
  orderBy,
  addDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";

const COLLECTION = "sponsoren";

export async function fetchSponsoren() {
  const q = query(collection(db, COLLECTION), orderBy("reihenfolge", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function createSponsor(daten) {
  const ref = await addDoc(collection(db, COLLECTION), daten);
  return ref.id;
}

export async function updateSponsor(id, daten) {
  await updateDoc(doc(db, COLLECTION, id), daten);
}

export async function deleteSponsor(id) {
  await deleteDoc(doc(db, COLLECTION, id));
}
